// @flow
import get from 'lodash/get';
import TrackingApi from '../../../sdk/tracking/Api';
import clientConfig from '../../../../parameters/client/config';
import {
  getFilters,
  getSuggester,
  getSearchParameterWhatD,
  getSearchParameterWhere,
  getTypeId,
} from '../../../Serp/selectors';
import { EVENT_NAME, API_TRACKING_ENDPOINT } from './constants';
import { getVerticalId, getCountryCode } from '~/common/selectors/config';
import {
  getQuery,
  getAbTest,
  getTrovitPageViewId,
  getUserAgent,
  getUserIp,
  getOrigin,
} from '~/common/selectors/trovit';

type ApiTrackingPayload = {
  pageViewId: string,
  typeId?: number,
  countryCode: string,
  verticalId: number,
  what: ?string,
  where: ?string,
  aBTestId: number,
  aBTestOption: string,
  ip: string,
  userAgent: string,
  page: number,
  isForm: boolean,
  alertsList: (?{
    at: string,
    v: number,
    suggested: boolean,
    we: string,
    sug?: number,
  })[],
  originId: number,
  alertSectionId: number,
  suggester: ?number,
  filters: Object,
  tracking: Object,
};

export const apiInstance = new TrackingApi(clientConfig.trackingApi);

function apiTracking(state: Object, { sectionId, isForm }: { sectionId: number, isForm: boolean }) {
  function mapStateToPayload(): ApiTrackingPayload {
    const query = getQuery(state);
    const abTest = getAbTest(state);
    const verticalId = getVerticalId(state);
    const what = getSearchParameterWhatD(state);
    const where = getSearchParameterWhere(state);
    const filters = getFilters(state);
    const suggester = getSuggester(state);

    return {
      pageViewId: getTrovitPageViewId(state),
      typeId: getTypeId(state) || undefined,
      countryCode: getCountryCode(state),
      verticalId,
      what: what || undefined,
      where: where || undefined,
      aBTestId: get(abTest, 'id'),
      aBTestOption: get(abTest, 'option'),
      ip: getUserIp(state),
      userAgent: getUserAgent(state),
      page: get(query, 'page'),
      isForm,
      alertsList: [
        {
          at: 'alert',
          v: verticalId,
          suggested: false,
          w: what || '',
          we: where || '',
        },
      ], // Change this when alert suggestion are implemented
      originId: getOrigin(state),
      alertSectionId: sectionId,
      suggester: suggester && suggester !== '0' ? suggester : undefined,
      filters: filters ? getFilters(state) : {},
      tracking: get(query, 'tracking'),
    };
  }

  function send() {
    const payload = mapStateToPayload();
    return apiInstance.sendTracking(API_TRACKING_ENDPOINT, payload);
  }

  return {
    name: EVENT_NAME,
    send,
    mapStateToPayload,
  };
}

export default apiTracking;



// WEBPACK FOOTER //
// ./app/tracking/events/internalstatsAlertImpression/apiTracking.js